export const blackListNames = [
    'default',
    'selectors',
    'defaultState',
];

const createSelectors = (selectorNames, subtree) => {
    const selectors = {};
    Object.keys(selectorNames).forEach(
        (funcName) => {
            if (!blackListNames.includes(funcName)) {
                selectors[funcName] = (state, ...rest) => selectorNames[funcName](state[subtree], ...rest);
            }
        },
    );
    return selectors;
};

export default createSelectors;
